import colors from "./colors"
import * as constants from "../default/constants"

const root = {
  name: "Dark",
  version: "0.0.1",
}

export const DarkTheme = {
  ...root,
  constants,
  colors,
}
